<app-header></app-header>
<div class="container">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>